export default __webpack_public_path__ + "static/sustainability-daf903eeddb522242bf5c73668b7327c.webp";